"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "All Courses",
    "className": "Workshop Name",
    "continue": "Continue",
    "courseChapter": "Chapter",
    "courseEvaluate": "Evaluation",
    "courseHours": "Credit",
    "courseInfo": "Detail",
    "courseNote": "Notes",
    "coursesCategory": "Course Categories",
    "electiveCourses": "Optional Course",
    "pages": "Page",
    "relatedCourses": "Relevant courses",
    "requiredCourses": "Lecture",
    "searchTips": "Please Input Course Name",
    "studentsNum": "Audiences",
    "teachersDesc": "Teacher",
    "newCourse": "Latest courses"
  },
  "footer_zlb": {
    "aboutUs": "About Us",
    "downLoad": "APP Download",
    "qr": "QR code"
  },
  "global_zlb": {
    "am": "AM",
    "isa": "　",
    "night": "Evening",
    "pm": "PM"
  },
  "header_zlb": {
    "accoutPw": "Account Password",
    "curDis": "Ongoing",
    "curUser": "Current User",
    "edit": "Update",
    "helpCenter": "Help Center",
    "hisDis": "History",
    "index": "Home",
    "joinStore": "Add to favorites",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "Message",
    "setIndex": "Set as home page",
    "userImg": "Profile Pic"
  },
  "index_zlb": {
    "discuss": "Workshop",
    "find": "Discover",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "Me"
  },
  "info_zlb": {
    "admin": "Administrator",
    "hasAgenda": "You have already joined the Agenda.",
    "noDown": "No attachments to download!",
    "pleaseInp": "Please Enter",
    "submit": "Successfully submitted!",
    "withinTime": "Task has yet to start",
    "noSubmitWork": "Assignment not submitted"
  },
  "login_zlb": {
    "accountLogin": "Login",
    "accountNotEmpty": "Account must be filled",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "Cancel",
    "captchaNotEmpty": "Verification code must be filled",
    "captchaTips": "Incorrect verification code",
    "changeEmail": "Update Email",
    "changeEmailSuccess": "Email address updated successfully.",
    "changeEmailSuccessTips": "You have updated your email successfully.",
    "Confirm": "Confirm",
    "currentEmail": "Current Email",
    "emailCaptcha": "Email verification code",
    "emailCaptchaEmpty": "Email verification code cannot be empty",
    "encryEmail": "security Email",
    "error": "Verification code error",
    "forget": "Forget Password",
    "formerEamil": "Original Email",
    "incorrectTips": "Username or password input error",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "New Email",
    "newEmailBinded": "The new email is linked to your user account",
    "newEmailEmpty": "New email cannot be empty",
    "newEmailFomat": "The new email format is incorrect",
    "newEmailSupport": "The old and new Email addresses do not match",
    "prevStep": "Last step",
    "nextStep": "Next Step",
    "reset": "Reset",
    "loginNow": "Login now",
    "resetSuccess": "Reset succeeded",
    "resetSuccessTips": "You have reset your password successfully. Please go to login",
    "msgCaptcha": "SMS verification code",
    "getCaptcha": "Obtain verification code",
    "resetPassword": "Reset password",
    "loginFail": "Login failed, please try again!",
    "failTips": "Verification Failed",
    "inputUserName": "Username",
    "goHome": "Go to home",
    "passwordFormat": "Passwords must be 8-32 digits and contain numbers and uppercase and lowercase letters.",
    "surePasswordEmpty": "Confirm Password cannot be empty",
    "confirmNot": "The password and confirmation password are inconsistent",
    "changePasswordSuccess": "Password successfully updated",
    "continueLogin": "Log in again",
    "orError": "Incorrect username or password",
    "orgEmailEmpty": "The original  email cannot be empty",
    "orgEmailFormat": "The original email format is incorrect",
    "orgEmailNot": "The original email address is incorrect",
    "passWord": "Password",
    "surePassword": "Confirm Password",
    "passwordBits": "Passwords must be at least 6 characters in length",
    "passwordNotEmpty": "Password must be filled",
    "pWord": "Password",
    "sign": "Login",
    "uName": "Account",
    "userName": "Username",
    "validate": "Verification Code",
    "verification": "Please complete the verification below",
    "appdownload": "App download",
    "scancode": "Scan QR code to download",
    "poor": "Weak",
    "middle": "Medium",
    "strong": "Strong"
  },
  "login": {
    "logout": "Sign out successfully",
    "resetLoginTips": "You have successfully changed your password, you need to log in again, and automatically log out after 3 seconds",
    "sure": "Confirm",
    "cancel": "Cancel",
    "captchaNotEmpty": "Verification code must be filled",
    "accountNotEmpty": "Account must be filled",
    "passwordNotEmpty": "Password must be filled",
    "inputCaptcha": "Verification Code",
    "getCaptcha": "Obtain verification code",
    "inputOrigPassword": "Please enter the original password",
    "inputNewPassowrd": "Please enter a new password",
    "confimPassword": "Confirm Password",
    "changePassword": "Change Password",
    "nextStep": "Next Step",
    "resetPassword": "Reset password",
    "resetDone": "Password reset succeeded",
    "msgCaptcha": "Email verification code"
  },
  "look_zlb": {
    "aboutLecturer": "Relevant courses",
    "benginLearn": "Start Learning",
    "chapter": "Chapter",
    "delete": "Delete",
    "details": "Detail",
    "download": "Download",
    "dynamic": "News",
    "evaluation": "Evaluation",
    "hotDyc": "Trending",
    "lecture": "Open Course",
    "lecturer": "Teacher",
    "lectureTest": "Course Categories",
    "look": "Discover",
    "lookAll": "View All",
    "note": "Notes",
    "score": "Score"
  },
  "myMessage_zlb": {
    "passwordError": "Original password input error",
    "aboutUs": "About Us",
    "allcourse": "All Courses",
    "atypism": "The two passwords do not match",
    "birth": "Date of birth",
    "cancel": "Cancel",
    "carryOut": "Complete",
    "changePassword": "Change Password",
    "chineseName": "Chinese name",
    "chineseNamePlaceholder": "Please enter Chinese name",
    "code": "Verification Code",
    "codeError": "Verification code error",
    "comment": "Comment",
    "complete": "Complete",
    "completeUserInfo": "Please complete personal information",
    "confirm": "Confirm Password",
    "continueStudy": "Continue",
    "country": "Country",
    "countryName": "Name",
    "countryNamePlaceholder": "Please enter your name",
    "countryPlaceholder": "Please select a country",
    "courseLearned": "Completed",
    "delete": "Delete",
    "documentType": "Type of ID document",
    "downloaded": "Downloaded",
    "downloading": "Downloading",
    "eduLevel": "Education Level",
    "eduLevelPlaceholder": "Please select education level",
    "email": "Email",
    "emailCode": "Email verification code",
    "gender": "Gender",
    "genderPlaceholder": "Please select gender",
    "getCode": "Get email verification code",
    "hasSent": "Sent",
    "helpCenter": "Help Center",
    "hour": "Hour",
    "improveInformation": "Please complete your personal information",
    "joinClasses": "Courses attended",
    "joinDis": "Workshops attended",
    "learned": "Finished",
    "learning": "In progress ",
    "lecture": "Course",
    "mailbox": "Email",
    "mailboxValidate": "Email verification failed",
    "man": "Male",
    "management": "Settings",
    "minutes": "x hours x minutes",
    "modify": "Update",
    "modifyEmail": "Update Email",
    "my": "Myself",
    "myCertificate": "My Certificate",
    "mycourse": "My Course",
    "myDownload": "My download",
    "myLecture": "My Course",
    "myNotes": "My Note",
    "newMail": "New Email",
    "newPassword": "New Password",
    "nextStep": "Next Step",
    "orError": "Incorrect username or password",
    "origin": "From",
    "originalPassword": "Original Password",
    "password": "Password",
    "phone": "Phone Number",
    "pleChoose": "Please select the date of birth",
    "post": "Post",
    "postPlaceholder": "Please enter post",
    "religion": "Religion",
    "religionPlaceholder": "Please choose religion",
    "retrievePassword": "Retrieve password",
    "setUp": "Settings",
    "signOut": "Log out",
    "something": "I would like to say",
    "submit": "Submit",
    "sureDelte": "Please make sure you want it deleted?",
    "teacher": "Lecturer",
    "learnYet": "Haven't started learning yet",
    "uName": "Username",
    "uNamePlaceholder": "Username",
    "userCenter": "Personal info",
    "username": "Username",
    "validateMsg": "Verification Failed",
    "woman": "Female",
    "learnTo": "Progress",
    "myRecord": "My record",
    "plePhone": "Please enter phone number"
  },
  "notice_zlb": {
    "delete": "Delete",
    "home": "Home",
    "lettre": "Private message",
    "lettreEmpty": "Private message cannot be empty",
    "messageDetail": "Message Details",
    "myMessage": "My message",
    "notice": "Notice",
    "nowBavarder": "Now you can start chatting",
    "send": "Send"
  },
  "play_zlb": {
    "networkTip": "Network notification",
    "streamHighTip": "The current network connection is stable. We have switched to high definition mode for you.",
    "streamHighType": "HD",
    "streamNormTip": "The current network connection is unstable. We have switched to standard definition mode for you.",
    "streamNormType": "SD",
    "liveTimeDes": "Live time",
    "livePlayWait": "Live not started",
    "livePlayEnd": "Live ended"
  },
  "questionnaire_zlb": {
    "handed": "Submit",
    "saveFailed": "Save failed",
    "examList": "List of test questions"
  },
  "research_zlb": {
    "afternoon": "PM",
    "all": "All",
    "allCalendar": "All Agenda",
    "alumniBook": "Member",
    "broadcast": "x start broadcast",
    "carriedout": "In Progress",
    "certificate": "Certificate",
    "comment": "Comment",
    "comments": "All x comments",
    "courses": "Reference",
    "curDis": "Ongoing",
    "default": "Not started",
    "delete": "Delete",
    "detail": "Detail",
    "discuss": "Forum",
    "end": "Ended",
    "endAssess": "Evaluation Ended",
    "enterAssess": "Begin Evaluation",
    "assessButton": "Feedback",
    "evaluation": "Evaluation",
    "fileAcept": "Wrong file type,Please upload again.",
    "fileSize10": "The selected file exceeds 10m, please upload again.",
    "hisDis": "History",
    "lecture": "Reference",
    "live": "Live",
    "livebroadcast": "Livestream",
    "minutes": "x minutes ago",
    "month": "Month",
    "morning": "AM",
    "noDiscussion": "No Workshop",
    "noSchedule": "No Agenda",
    "notice": "Notice",
    "notification": "Unread notice",
    "offline": "Face-to-face lecture",
    "onging": "In Progress",
    "online": "Online",
    "operation": "Assignment",
    "over": "Ended",
    "participated": "Already Participated ",
    "notParticipate": "Yet to Participate ",
    "failedCourse": "Not Pass",
    "passedCourse": "Pass",
    "preparation": "Task preparation",
    "preparations": "Task preparation",
    "preschoolLecture": "Warm-up lecture",
    "questionnaire": "Questionnaire",
    "questionType ": "multiple choic(only one answer is correct;mark out all corrrect answers)",
    "readySay": "I would like to say",
    "replies": "You have x new replies",
    "save": "Save",
    "schedule": "Agenda",
    "searchC": "Search for topics you are interested in",
    "seeAssess": "View Evaluation",
    "submit": "Submit",
    "submitHomewor": "Cancel",
    "task": "Task",
    "taskToday": "Task for today",
    "video": "Video",
    "week": "Week",
    "yourcomment": "Write down your comment",
    "legend": "Legend",
    "sunday": "Sunday",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "consult": "Reference Materials",
    "schedules": "Tasks",
    "calendar": "Calendar",
    "waitAssesment": "Questionnaire to be submitted",
    "year": "Year",
    "day": "Day",
    "preview": "Preview",
    "resource": "Download"
  },
  "retrieve_zlb": {
    "emailEmpty": "Email address cannot be empty.",
    "emailVerif": "Email verification"
  },
  "task_zlb": {
    "downF": "Download Attachments",
    "repeatUp": "Re-upload",
    "ruY": "If one attachment has been uploaded on APP, it will be overwritten if you upload another on PC.",
    "submitC": "Please enter what you want to submit",
    "uploadF": "Upload Attachments"
  },
  "upload_zlb": {
    "clickHere": "click here",
    "limit": "File format supports PNG, JPG size cannot exceed",
    "preview": "Preview after uploading the picture",
    "upload": "Upload"
  },
  "index": {
    "setAsHomePage": "Set as home page",
    "addCollection": "Add to favorites",
    "telephone": "Hotline",
    "Help": "Help Center",
    "SystemMessage": "System notification",
    "message": "Private message",
    "emptyMessage": "Clear",
    "checkAllMessage": "View All",
    "noMessage": "No data",
    "fullScreen": "Full screen display",
    "ExitSystem": "Exit this system",
    "back": "Back",
    "top": "Top",
    "backToTop": "Back to top",
    "homePage": "Home",
    "favoriteTips": "Due to the limitation of 360 browser / Google browser, please press Ctrl + D to manually collect!",
    "autoSetHomeTips": "Your browser does not support automatic setting of home page, please use browser menu to set it manually!",
    "currentUser": "Current User",
    "userHead": "Profile Pic",
    "accountPassword": "Account Password",
    "change": "Update",
    "head": "Profile Pic",
    "continueStudy": "Continue",
    "startStudy": "Start Learning"
  },
  "course": {
    "count": "general",
    "item": "Article",
    "up": "Previous page",
    "next": "Next page",
    "items": "per page",
    "go": "Jump to",
    "page": "Page",
    "man": "User",
    "score": "Score",
    "courseYear": "Year",
    "courseTeachers": "Lecturer",
    "noDesc": "No introduction",
    "teachersDesc": "Teacher profile",
    "checkLog": "View records",
    "startStudy": "Start Learning",
    "JoinLearning": "Join",
    "isEvaluate": "Evaluated",
    "deleteNoteButton": "Delete",
    "closeButton": "Close",
    "noteSource": "From"
  },
  "onlineclass": {
    "myScore": "My score",
    "comments": "Comment",
    "iknow": "I know",
    "detail": "Detail",
    "inforCertificate": "Certificate",
    "wantTalk": "I want to comment it",
    "inputTalkContent": "Please enter the comment",
    "publish": "Release",
    "undo": "Cancel",
    "reply": "Reply",
    "delete": "Delete",
    "Learned": "Completed",
    "isDelete": "Are you sure you want to delete it?",
    "submitTime": "Submission time",
    "to": "to",
    "download": "Download"
  },
  "usercenter": {
    "htllo": "Hello",
    "welcomeMessage": "Have a nice day",
    "searchTips": "Search for the course you like",
    "myCertificate": "My Certificate",
    "startQuestionnaire": "Start answering the paper",
    "empty": "nothing",
    "confirmDelete": "Deletion confirm",
    "confirmDeleteTips": "Are you sure you want to delete it?",
    "delete": "Delete",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "End learning",
    "tips": "Tips",
    "playTips": "Tips: Please click \"End Learning\" button in the top right corner to exit. If you quit learning by closing the browser, your learning time may not be recorded correctly.",
    "notShowAgain": "Don't remind me again",
    "gotIt": "I know",
    "chapter": "Chapter",
    "language": "Language",
    "chapterText1": "No.",
    "chapterText2": "Chapter",
    "note": "Notes",
    "noteBlockTitle": "Notes",
    "evaluate": "Evaluation",
    "evaluateStar": "Star",
    "saveEvaluate": "Submit",
    "notePlaceholder": "Please take notes",
    "closeTips": "The changes you made may not be saved",
    "closeButton": "Leave",
    "autoStop": "Automatically stop playing",
    "autoStopTips": "User inactivity timeout.Playback stops automatically.",
    "confirmOut": "Are you sure you want to quit playing?",
    "closeOrNot": "Close the current window",
    "noCoursePlay": "No playable souces found in the current course",
    "attention": "Attention, please!"
  },
  "assessment_zlb": {
    "score": "Score",
    "evalSuccess": "Evaluation successfully"
  },
  "undefined": {
    "undefined": "Note que o conteúdo não pode estar vazio"
  }
};